import React, { useEffect, useState } from 'react';
import { XFilled } from '@weee-fe/kunlunicon';
import { twMerge } from 'tailwind-merge';
import { loyaltyLevel } from '@/api/customer';
import { isSayWeeeApp } from '@/utils/common/device';
import callAppFunction from '@/utils/bridge';
import { appOnPopupWindowDidFinish } from '@/utils/business';
import { useRouter } from 'next/router';
import { CroppedImage } from '@weee-fe/module';
import switchImageDomain from '@/utils/common/switchImageDomain';

interface Props {
  data?: any;
  visible?: boolean;
  onCancel?: () => void;
}

const COLOR_MAP = {
  1: {
    bg: '#FFB66C',
    color: '#954315'
  },
  2: { bg: '#B7C7E1', color: '#1F3672' },
  3: { bg: '#FFEB85', color: '#9C7000' }
};

const RewardsSavingContent = (props: Props) => {
  const router = useRouter();
  const { visible, onCancel, data } = props;
  const [savingData, setSavingData] = useState(data);
  const { content, sub_contents, level } = savingData || {};

  useEffect(() => {
    if (visible && !data) {
      const getRewardsData = async () => {
        const res = await loyaltyLevel();
        res?.result &&
          setSavingData({
            level: res?.object?.current_level,
            ...res?.object?.savings_details
          });
      };
      getRewardsData();
    }
  }, [data, visible]);

  useEffect(() => {
    if (isSayWeeeApp() && !!document?.getElementById('loyaltybenefits')) {
      const popup = () => {
        const element = document?.getElementById('popcontainer');
        const elementHeight = element?.clientHeight;
        const popheight = +router?.query?.['__popup_height__'] || 300;
        let show = false;
        const args = {
          width: -1,
          height: elementHeight > 600 ? 600 : elementHeight > popheight ? elementHeight : popheight
        };
        callAppFunction('popupWindowSizeChanged', args, function (res) {});
        if (!show) {
          appOnPopupWindowDidFinish();
          show = true;
        }
      };
      popup();
    }
  }, [JSON.stringify(savingData)]);

  return (
    <div id="popcontainer">
      <div className="fixed top-0 inset-x-0 h-[60px] flex items-center justify-center bg-white">
        <div className="absolute left-4 top-1/2 -translate-y-1/2 p-1 z-[1]" onClick={onCancel}>
          <XFilled className="text-[20px]" />
        </div>
        {!content?.desc ? (
          <div className="h-6 w-40 skeleton rounded-300"></div>
        ) : (
          <div className="pl-12 pr-6 mx-auto flex items-center justify-center">
            <CroppedImage
              url={switchImageDomain(content?.icon)}
              width={24}
              height={24}
              configs={{ renderWidth: 24, renderHeight: 24 }}
              wrapperClassName="!h-6 !w-6"
              alt="Weee!- Rewards"
              type="img"
            />
            <p className="enki-body-base-medium text-[#111] px-1 line-clamp-1">{content?.desc}</p>
          </div>
        )}
      </div>
      <div className="p-6 pt-16">
        {!sub_contents?.length ? (
          <>
            {[1, 2, 3]?.map((item, i) => {
              return (
                <div
                  key={`saving-${i}`}
                  className={twMerge(
                    'flex items-center mb-4',
                    i === 0 && 'pb-4 border-b border-solid border-[#f3f3f3]'
                  )}>
                  <div className="rounded-300 mr-3 w-[68px] h-16 skeleton bg-[#f3f3f3]"></div>
                  <div className="flex-1">
                    <p className="mb-0.5 h-5 rounded-300 skeleton bg-[#f3f3f3] "></p>
                    <p className="h-5 rounded-300 skeleton bg-[#f3f3f3] "></p>
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <div id="loyaltybenefits">
            {sub_contents?.map((item, i) => {
              return (
                <div
                  key={`saving-${i}`}
                  className={twMerge(
                    'flex items-center mb-4 text-[#111]',
                    i === 0 && 'pb-4 border-b border-solid border-[#f3f3f3]'
                  )}>
                  <div
                    className={twMerge(
                      'rounded-300 mr-3 shrink-0 enki-body-3xs-strong !tracking-normal w-[72px] h-[72px] flex items-center justify-center bg-[#f3f3f3]'
                    )}
                    style={{
                      background: i === 0 && COLOR_MAP[level]?.bg
                    }}>
                    {item?.amount}
                  </div>
                  <div className="flex-1">
                    <p
                      className="enki-body-sm-medium mb-0.5"
                      style={{
                        color: i === 0 && COLOR_MAP[level]?.color
                      }}>
                      {item?.title}
                    </p>
                    <p
                      className="enki-body-2xs text-[#777]"
                      style={{
                        color: i === 0 && COLOR_MAP[level]?.color
                      }}>
                      {item?.desc}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default RewardsSavingContent;
